import { apiGetText, apiPutText } from "./http";

export async function fetchOrgStructureJson(tenantLegacyId: string): Promise<string> {
  return apiGetText(`/api/tenants/${encodeURIComponent(tenantLegacyId)}/org-structure`);
}

export async function putOrgStructureJson(tenantLegacyId: string, json: string): Promise<string> {
  let body: unknown = json;
  try {
    body = JSON.parse(json);
  } catch {
    body = [];
  }
  return apiPutText(`/api/tenants/${encodeURIComponent(tenantLegacyId)}/org-structure`, body);
}
